<template>
	<div class="form-group" v-html="field.text"></div>
</template>

<script>
export default {
	props: ['field']
};
</script>